var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvent1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46089 13.1524L7.69073 14.1118C7.12274 14.8214 6.84356 15.1711 6.44886 15.361C6.06378 15.5509 5.62094 15.5509 4.73526 15.5509H3.84958M6.8917 7.41599L7.787 6.85634C9.20217 5.97689 9.95307 5.50718 10.7329 5.38726C10.9061 5.35728 11.0698 5.35728 11.2431 5.37726C12.5716 5.52717 13.4188 6.4366 14.1215 7.59588C14.8917 8.86508 15.7774 9.03498 17 9.03498M12.0614 6.14678L10.4152 8.28545C9.79904 9.08495 9.48135 9.49469 9.43321 9.93442C9.40433 10.1843 9.43321 10.4341 9.51986 10.664C9.67389 11.0737 10.0686 11.3835 10.858 12.0131C11.4645 12.4828 11.7629 12.7227 11.9651 13.0325C12.0806 13.2124 12.1769 13.4022 12.2347 13.6021C12.3502 13.9619 12.4079 14.5415 12.3502 15.1312C12.2732 15.9007 11.6955 17 11.6955 17M4.51384 4.74766H2.34777M7.29603 2.51905H4.15764M3.16606 6.97626H1M16.9904 2.84884C16.9904 3.86821 16.1913 4.69769 15.2094 4.69769C14.2274 4.69769 13.4284 3.86821 13.4284 2.84884C13.4284 1.82948 14.2274 1 15.2094 1C16.1913 1 16.9904 1.82948 16.9904 2.84884Z",
    stroke: "#4F4F4F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent1);
export default __webpack_public_path__ + "static/media/event1.5d2b611ad62a28dc08e6dfebb7ad4fbe.svg";
export { ForwardRef as ReactComponent };